import React, { RefObject, useEffect, useRef } from 'react';
import InfoRow from 'components/Info/InfoRow';
import { HeadingS } from 'components/Typography/Typography';
import { makeStyles } from '@material-ui/core';
import summaryStyle from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/summaryStyle';
import { useSelector } from 'react-redux';
import { getFiberProLabels } from 'redux/modules/dynamicLabels/selectors';

interface ISummaryProps {
	location: { [name: string]: string };
	contactDetails: types.services.fixed.IContactDetails;
	setNextStepDisabled: (nextStepDisabled: boolean) => void;
}

const location = ['governorate', 'willayat', 'town', 'buildingNumber', 'wayNumber'];
const contact = ['reqName', 'contactNo', 'bestTime', 'workingNumber'];

// @ts-ignore
const useStyles = makeStyles(summaryStyle);

const PstnFbbSummaryTab = (props: ISummaryProps) => {
	const { setNextStepDisabled } = props;
	const fiberProLabels = useSelector(getFiberProLabels);
	const classes = useStyles();
	// this component get focussed - for accessibility
	const ref: RefObject<HTMLDivElement> = useRef(null);
	useEffect(() => {
		if (ref.current) ref.current.focus();
	}, []);
	useEffect(() => {
		setNextStepDisabled(false);
	}, [setNextStepDisabled]);
	return (
		<div ref={ref}>
			<div className={classes.header}>
				<HeadingS color="secondary-light">{fiberProLabels.locDetails}</HeadingS>
			</div>
			{location.map((key) => (
				<div key={key} className={classes.data}>
					<InfoRow title={fiberProLabels[key]} value={props.location[key]} key={key} />
				</div>
			))}

			<div className={classes.header}>
				<HeadingS color="secondary-light">{fiberProLabels.contactTabName}</HeadingS>
			</div>
			<div>
				{contact.map((key) => (
					<div key={key} className={classes.data}>
						<InfoRow title={fiberProLabels[key]} value={props.contactDetails[key]} />
					</div>
				))}
			</div>
		</div>
	);
};

export default PstnFbbSummaryTab;
